module.exports = __webpack_public_path__ + "static/media/gateway1.cb668f0f.jpg";